(function () {
  'use strict';

  angular
    .module('events.vehicles.deposits.edit')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('events.vehicles.deposits.edit', {
        url: '/:depositId/edit',
        templateUrl: 'events/vehicles/deposits/edit/edit.tpl.html',
        controller: 'DepositsEditCtrl',
        controllerAs: 'vm'
      })
      .state('events.vehicles.deposits.add', {
        url: '/add',
        templateUrl: 'events/vehicles/deposits/edit/edit.tpl.html',
        controller: 'DepositsEditCtrl',
        controllerAs: 'vm'
      })
    ;
  }
}());
